/**
 * Generates the share URL with the correct domain.
 * Always uses easyfinder.fr for production, localhost for development.
 */
export function getShareUrl(token: string, isCollection: boolean = false): string {
  const hostname = window.location.hostname;
  
  // Use localhost for local development only
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const baseUrl = isLocalhost ? window.location.origin : 'https://easyfinder.fr';
  
  const path = isCollection ? `/share/collection/${token}` : `/share/${token}`;
  return `${baseUrl}${path}`;
}
